import styled, { css } from "styled-components";
import { media, theme } from "../../theme";
import {  getFontSetNames } from "../../utils/getFontSetLabels";
import { ProfileFontSet } from "@authory-packages/core";

export const BrandingOptionsBottomBarWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        flex-direction: row;
        align-items: flex-start;
    }

    > div {
        margin-bottom: 15px;

        ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
            margin-right: 40px;
            margin-bottom: 0;
        }
    }
`;



const preloadfontCSS = css`
    width: 0;
    height: 0;
    opacity: 0;
    visibility: hidden; 
    position: absolute;
    pointer-events: none;
`;


export const PreloadFontHeading = styled.span.attrs<{$fontFamily: ProfileFontSet}>(
    ({ $fontFamily }) => ({
        style: {
            fontFamily:  getFontSetNames($fontFamily).headingLabel
        },
    })
)`
   ${preloadfontCSS}
`;

export const PreloadFontParagraph = styled.span.attrs<{$fontFamily: ProfileFontSet}>(
    ({ $fontFamily }) => ({
        style: {
            fontFamily:  getFontSetNames($fontFamily).paragraphLabel
        },
    })
)`
   ${preloadfontCSS}
`;